import React from 'react';
import { Redirect, Route, useParams } from 'react-router-dom';
import EnableForProjectState from '../security/EnableForProjectState';

import DivestitureDiagnosticContent from './DivestitureDiagnosticContent';

import './DivestitureDiagnosticContentRouter.scss';
import { divestitureRoute } from './routes';

const DivestitureDiagnosticContentRouter = () => {
  const { projectId } = useParams();

  return (
    <Route path={divestitureRoute}>
      <EnableForProjectState projectId={projectId}>
        {({ isProjectDisabled }) =>
          isProjectDisabled ? (
            <Redirect to={`/projects/${projectId}`} />
          ) : (
            <DivestitureDiagnosticContent />
          )
        }
      </EnableForProjectState>
    </Route>
  );
};

export default DivestitureDiagnosticContentRouter;
